import { render, staticRenderFns } from "./consignorComment.vue?vue&type=template&id=36292c5a&scoped=true&"
import script from "./consignorComment.vue?vue&type=script&lang=js&"
export * from "./consignorComment.vue?vue&type=script&lang=js&"
import style0 from "./consignorComment.vue?vue&type=style&index=0&id=36292c5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36292c5a",
  null
  
)

export default component.exports